export default "__VITE_ASSET__DcX6VHUj__"